export type ProjectCategory = 'game-interaction' | 'product-design' | 'student-project' | 'other'

export interface EducationItem {
  school: string
  degree: string
  department: string
  period: string
}

export interface ExperienceItem {
  company: string
  title: string
  project?: string
  period: string
  bullets: string[]
}

export interface PortfolioLink {
  label: string
  url: string
}

export interface ProjectGalleryItem {
  image_url: string
  image_alt: string
  caption?: string
}

export interface Profile {
  id?: string
  owner_id?: string
  name: string
  initials: string
  headline: string
  bio: string
  location: string
  email: string
  phone?: string
  availability: string
  resume_path?: string | null
  resume_url?: string | null
  years_experience?: string
  project_count?: string
  education?: EducationItem[]
  experiences?: ExperienceItem[]
  skills?: string[]
  portfolio_links?: PortfolioLink[]
}

export interface Project {
  id: string
  owner_id?: string
  slug: string
  title: string
  category: ProjectCategory
  summary: string
  role: string
  period: string
  tags: string[]
  cover_path?: string | null
  cover_url?: string | null
  cover_alt?: string
  content: string
  highlights: string[]
  gallery?: ProjectGalleryItem[]
  featured: boolean
  status?: 'draft' | 'published'
  sort_order?: number
}

export interface PortfolioPayload {
  profile: Profile
  projects: Project[]
  access?: {
    label?: string
    expires_at?: string | null
  }
}

export interface ShareLink {
  id: string
  label: string
  token: string
  expires_at: string | null
  revoked_at: string | null
  view_count: number
  created_at: string
}

export const CATEGORY_LABELS: Record<ProjectCategory, string> = {
  'game-interaction': '游戏交互',
  'product-design': '产品设计',
  'student-project': '学生项目',
  other: '其他项目',
}
